import { useLayoutEffect, useRef, useState } from "react";

export const useElementSize = <TElement extends HTMLElement = HTMLElement>() => {

  const ref = useRef<TElement>(null);
  const [ size, setSize ] = useState<{ width: number, height: number }>();

  useLayoutEffect(() => {
    if (!ref.current)
      return;

    const update = () => setSize({ width: ref.current!.offsetWidth, height: ref.current!.offsetHeight });
    const observer = new ResizeObserver(update);
    observer.observe(ref.current);
    update();

    return () => observer.disconnect();
  }, [ ref ]);

  return { ref, size };

}
